import { render, staticRenderFns } from "./app.vue?vue&type=template&id=0dc52be0&scoped=true&lang=pug"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"
import style0 from "./app.vue?vue&type=style&index=0&id=0dc52be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc52be0",
  null
  
)

export default component.exports